const MONTH_OFFSET: number = 1;

export const isCycleClosed = (
  year: number,
  monthIndex: number,
  reference: Date,
): boolean => {
  const lastDayOfCycleMonth: Date = new Date(
    year,
    monthIndex + MONTH_OFFSET,
    0,
    23,
    59,
    59,
    999,
  );

  return reference.getTime() > lastDayOfCycleMonth.getTime();
};
